import { PriceAmountType } from '../constants/price-amount-type.js';
// WHY: single source for this label map -- it was previously duplicated across four files with inconsistent casing.
export const PRICE_AMOUNT_TYPE_LABELS = {
    [PriceAmountType.WHOLESALE]: 'Wholesale',
    [PriceAmountType.LIST]: 'List',
    [PriceAmountType.MSRP]: 'MSRP',
};
//# sourceMappingURL=price-amount-type-labels.js.map